import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import P from '@deliveroo/consumer-component-library/components/P';
import styles from './styles.scss';

export default function LandingPageBreadcrumbs({ links }) {
  const tags = links.map(({ label, href }, index) => (
    <Fragment key={label}>
      {href && (
        <a href={href} className={styles.breadcrumb}>
          {label}
        </a>
      )}
      {!href && label}
      {index < links.length - 1 && <Fragment>&nbsp;/&nbsp;</Fragment>}
    </Fragment>
  ));

  return <P color="white">{tags}</P>;
}

LandingPageBreadcrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    }),
  ).isRequired,
};
